// Approved product targets; the final pack labels remain pending.
export const variants = {
  brownRicePea: {
    id: "lenis-pea-brown-rice", name: "Pure Brown Rice & Pea Protein Isolate",
    flavour: "Cocoa", protein: 22, serving: 30, servings: 33,
    packSize: "1,000 g", vegan: true, comingSoon: false, artwork: "/brand/showcase/plant-pouch.webp", artworkWidth: 1242, artworkHeight: 1266,
  },
  cocoa: {
    id: "lenis-egg-white", name: "Pure Egg White Protein Isolate",
    flavour: "Cocoa", protein: 24, serving: 30, servings: 33,
    packSize: "1,000 g", vegan: false, comingSoon: true, artwork: "/brand/showcase/egg-white-pouch.webp", artworkWidth: 1024, artworkHeight: 1536,
  },
};
export const variantForProduct = (product = {}) =>
  /egg/i.test(product.id || product.name || "") ? variants.cocoa : variants.brownRicePea;


